import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import Timestamp from './timestamp';
import Speaker from './speaker';
import Token from './token';

export default class Sentence extends Component {
    static propTypes = {
        fontSize: PropTypes.string,
        segment: ImmutablePropTypes.map.isRequired,
        showSpeaker: PropTypes.bool,
        showTimestamp: PropTypes.bool,
        showSearchResults: PropTypes.bool,
        highlightTokensByTime: PropTypes.bool,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        showSpeaker: false,
        showTimestamp: false,
        showSearchResults: false,
        highlightTokensByTime: false,
        onClick: null,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.segment !== this.props.segment
            || nextProps.showSpeaker !== this.props.showSpeaker
            || nextProps.highlightTokensByTime !== this.props.highlightTokensByTime;
    }

    render() {
        const {segment, showSpeaker, showTimestamp, showSearchResults, highlightTokensByTime, onClick} = this.props;
        const segmentIndex = segment.get('path').first();
        const speakerChange = segment.get('speakerChange');
        const children = [];

        if (showTimestamp) {
            children.push(<Timestamp key={`timestamp-${segmentIndex}`} time={segment.get('startTime')} />);
        }

        const speaker = segment.get('speaker');
        if (speaker && showSpeaker && (speakerChange || segmentIndex === 0)) {
            children.push(<Speaker key={`speaker-${segmentIndex}`} speaker={speaker} />);
        }

        segment.get('sequences').forEach(sequence => {
            const lastTokenIndex = sequence.get('tokens').size - 1;
            sequence.get('tokens').forEach((token, tokenIndex) => {
                children.push(
                    <Token
                        key={`token-${token.get('path').join('-')}`}
                        token={token}
                        addSpace={tokenIndex === lastTokenIndex}
                        showSearchResults={showSearchResults}
                        highlightByTime={highlightTokensByTime}
                        onClick={onClick}
                    />,
                );
            });
        });

        const style = this.props.fontSize ? {fontSize: this.props.fontSize} : undefined;
        const className = classNames(
            'cielo24-vwrap-sentence',
            {'cielo24-vwrap-highlight-time': segment.getIn(['highlight', 'time'])},
        );

        return (
            <p
                style={style}
                className={className}
                data-start-time={segment.get('startTime')}
                data-end-time={segment.get('endTime')}
            >
                {children}
            </p>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/transcript/sentence.js